import { Typography } from '@growdash/design-system/atoms';
import React from 'react';

type Props = {
  children?: React.ReactNode;
  title: string;
};

export default function PageWithTitle({ title, children }: Props) {
  return (
    <>
      <Typography fontWeight={700} className="mb-4 text-primary text-[1.75rem]">
        {title}
      </Typography>
      <div className="animate-fade-in">{children}</div>
    </>
  );
}
